// extracted by mini-css-extract-plugin
export default {"section":"AdminRoute_section__927aj","main":"AdminRoute_main__oAHxK"};